import { Link } from 'react-router-dom';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { PageEmptyState } from '@/platform/design-system/components/ui/PageEmptyState';

export function RouteNotFoundBoundary() {
  return (
    <main className="mx-auto flex min-h-[60vh] w-full max-w-3xl items-center px-4 py-10">
      <PageEmptyState
        stateKind="filtered-empty"
        icon={ExclamationTriangleIcon}
        eyebrow="Route not found"
        title="This Hyperion page does not exist"
        subtitle="Check the address or choose a current product destination. Retired routes are not silently redirected."
        actions={[
          {
            label: 'Return to Workbench',
            onClick: () => window.location.assign('/workbench'),
          },
        ]}
      >
        <Link className="text-sm font-medium text-accent-text underline" to="/switchboard">
          Browse available capabilities
        </Link>
      </PageEmptyState>
    </main>
  );
}
